export default __webpack_public_path__ + "static/media/Snd_LowerFUpDown.3334e0df.mp3";